import axios from 'axios';

import { TokenError } from '../exceptions/TokenError';
import { CardConfig, IGatewayConfig, IProvider } from '../types';
import { config } from '../config';

export class GetNet implements IProvider {
  private static apiUrl = config.API_ENDPOINT;

  constructor(
    private options: IGatewayConfig[],
    private gatewayId: string,
    private isTest?: boolean
  ) {}
  public async generate(config: CardConfig) {
    try {
      const result = await axios.post(`${GetNet.apiUrl}/tokenizer/${this.gatewayId}`, {
        ...config,
      });

      const token = result.data.token;

      return token;
    } catch (err) {
      throw new TokenError('Failed to generate token');
    }
  }
}
